import React from 'react';
import PropTypes from 'prop-types';

import QuotationMark from '../../../../../public/static/icons/quotation-mark.svg';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBQuoteSimple = ({
  quote,
  authorName = '',
  authorPosition = '',
  hasMobileQuotationMarks = false,
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb bb-quote bb-quote-simple ${
      styles['bb-quote-simple']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      <div className="media">
        <QuotationMark />

        <div className="media-body">
          <div className="quote">
            <q>
              <p>
                {hasMobileQuotationMarks && <span className="d-md-none">“</span>}
                {quote}
                {hasMobileQuotationMarks && <span className="d-md-none"> ”</span>}
              </p>
            </q>
          </div>

          {(authorName || authorPosition) && (
            <div className="author">
              {authorName && (
                <span className="name">
                  <mark>
                    {authorName}
                    {authorPosition ? ' - ' : ''}
                  </mark>
                </span>
              )}
              {authorPosition && (
                <span className="position">
                  <mark>{authorPosition}</mark>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

BBQuoteSimple.propTypes = {
  quote: PropTypes.string.isRequired,
  authorName: PropTypes.string,
  authorPosition: PropTypes.string,
  hasMobileQuotationMarks: PropTypes.bool,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBQuoteSimple;
